import React from 'react';

const Footer = () => (
  <footer className="footer">
    <div className="container-fluid">
      <p className="copyright pull-right">
        © 2021 SweRa Techno
      </p>
    </div>
  </footer>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/pages/Main/Footer.js